import React from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export default function RequiredSection() {
  return (
    <div className="create-new-project-pane__required-info">
      <span>*</span>
      <IDHFormattedMessage id="ws_required" defaultMessage="Required" />
    </div>
  );
}
